module.exports = __webpack_public_path__ + "static/Icon_HomeLoan_Large-22a9ef3cb32e6804029ff45c8e830473.png";